import DataTable, {
    Caption,
    TBody,
    THead
} from '../../../../components/DataTable'
import {
    getProductCode,
    getProductName,
    getProductBrandName,
    getProductSubcategoryName
} from '../../../../utilities/productDisplay'
import { LicenseInfo } from '../../types'

export default function Products({ data }: { data: LicenseInfo }) {
    const product_licenses = data.product_licenses.filter(
        product_license => product_license.memory
    )

    return (
        <DataTable scrollHeight={450}>
            <THead>
                <tr>
                    <th>Producto</th>
                    <th>Marca</th>
                    <th>Subcategoría</th>
                </tr>
            </THead>
            <TBody>
                {product_licenses.map(pl => (
                    <tr key={pl.id}>
                        <td>
                            <p className="-mb-1">
                                {getProductName(pl.product)}
                            </p>
                            <span className="text-2xs">
                                {getProductCode(pl.product)}
                            </span>
                        </td>
                        <td>{getProductBrandName(pl.product)}</td>
                        <td>{getProductSubcategoryName(pl.product)}</td>
                    </tr>
                ))}
                {product_licenses.length === 0 && (
                    <Caption colSpan={3}>No se encontraron resultados</Caption>
                )}
            </TBody>
        </DataTable>
    )
}
